import "jquery-validation";
import "jquery-validation/dist/additional-methods";

require("./validation_helper");

$(function () {
    $(".wrap_select")
        .find(".drop_button")
        .on("click", function () {
            $(".wrap_select").find(".drop_menu").fadeToggle();
        });

    if ($("#rd-section-c1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-c3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c3").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-c4").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-c4",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-c4").addClass("ani_do").removeClass("op0");
            },
        });
    }

    $(".rd_ask_the_topic").on("click", function () {
        $("#rd_ask_the_topic_name").text($(this).text());
        $("#rd_ask_the_topic_ul").hide();
        $(`input[name='ask_the_topic']`).val($(this).data("id"));
        $(`input[name='ask_the_topic']`)
            .closest(".rd_show_validator_error")
            .find(".rd_notice")
            .remove();
    });

    $("input[name='privacy']").on("click", function () {
        if ($(this).is(":checked")) {
            $(this)
                .closest(".rd_show_validator_error")
                .find(".rd_notice")
                .remove();

            $("#rd_privacy_wrong").removeClass("wrong");
        }
    });

    observeForm("#rd_contact_form", "#rd_submit_contact", {
        ignore: [":not(privacy)"],
        rules: {
            ask_the_topic: {
                required: true,
            },
            content: {
                required: true,
            },
            name: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },
            tel: {
                tel: true,
            },
            privacy: {
                required: true,
            },
        },
        messages: contactValidationTwMessage,
    });
});
